import { MenuService } from "./../../shared/services/menu.service";
import { Component, Input, OnInit } from "@angular/core";
import { AppTemplateComponent } from "../template/app.template.component";
import * as _ from "lodash";
import { AuthService } from "@app/shared/services/auth.service";
import { IMenu } from "@app/shared/interface/IMenu";
import { UserRoleEnum } from "@app/shared/enums/UserRoleEnum";
@Component({
  selector: "app-menu",
  templateUrl: "./app.menu.component.html",
})
export class AppMenuComponent implements OnInit {
  @Input() reset: boolean;

  menus: IMenu[];

  constructor(
    public template: AppTemplateComponent,
    private authSrv: AuthService,
    private menuSrv: MenuService
  ) {}

  async ngOnInit() {
    if (await this.authSrv.isAuthenticated()) {
      this.loadAuthenticatedMenus();
    } else {
      this.loadUnauthenticatedMenus();
    }
  }

  async loadUnauthenticatedMenus() {
    if (await this.authSrv.isAuthenticated()) {
      this.menus = [
        {
          label: "Percentual de Respostas por Questão",
          icon: "pi pi-fw pi-chart-bar",
          routerLink: ["percentage-answer-by-question"],
        },
        {
          label: "Questão e Unidade Fiscalizada",
          icon: "pi pi-fw pi-chart-bar",
          routerLink: ["by-question-and-org"],
        },
        {
          label: "Questionário e Unidade Fiscalizada",
          icon: "pi pi-fw pi-chart-bar",
          routerLink: ["by-questionnaire"],
        },
        {
          label: "Acompanhamento",
          icon: "pi pi-fw pi-chart-bar",
          items: [
            {
              label: "Andamento Fiscalização",
              icon: "pi pi-fw pi-chart-bar",
              routerLink: ["fiscalization-progress"],
            },
            {
              label: "Andamento Validação",
              icon: "pi pi-fw pi-chart-bar",
              routerLink: ["coefficient-validation-progress"],
            },
            {
              label: "Entrega Questionário",
              icon: "pi pi-fw pi-chart-bar",
              routerLink: ["delivery-questionnaire"],
            },
          ],
        },
        {
          label: "Coeficiência",
          icon: "pi pi-fw pi-chart-bar",
          routerLink: ["coefficient"],
        },
      ];
    }
  }

  loadAuthenticatedMenus() {
    const menus: IMenu[] = [];
    const userRoles = this.authSrv.getTokenRoles();
    const adm: boolean = userRoles.includes(UserRoleEnum.ADMIN);
    const manager: boolean = userRoles.includes(UserRoleEnum.MANAGER);
    const auditor: boolean = userRoles.includes(UserRoleEnum.AUDITOR);
    const consulta: boolean = userRoles.includes(UserRoleEnum.GRP_CEI_SUPORTE);

    if (adm) {
      menus.push(this.getDashBoard());
      menus.push(this.getBasics());
      menus.push(this.getPlanning());
      menus.push(this.getFiscalization(adm, auditor));
      menus.push(this.getConfiguration(userRoles));
      menus.push(this.getReports());
    }

    if (manager) {
      if (consulta) {
        menus.push(this.getDashBoard());
      }
      menus.push(this.getJurisdicted(manager, auditor));
      menus.push(this.getComunication());
      if (consulta) {
        menus.push(this.getPlanning());
        menus.push(this.getConfiguration(userRoles));
      }
    }

    if (auditor) {
      if (!adm) {
        menus.push(this.getReports());
        if (consulta) {
          menus.push(this.getDashBoard());
          menus.push(this.getPlanning());
          menus.push(this.getConfiguration(userRoles));
        }
        menus.push(this.getFiscalization(adm, auditor));
      }
      if (!manager) {
        menus.push(this.getJurisdicted(manager, auditor));
      }
    }

    if (!adm && !manager && !auditor && consulta) {
      menus.push(this.getDashBoard());
      menus.push(this.getPlanning());
      menus.push(this.getConfiguration(userRoles));
    }

    this.menus = menus;
    const urls = [];
    menus.forEach((m) => {
      if (m.routerLink && m.routerLink.length > 0) {
        m.routerLink.forEach((r) => {
          urls.push(r);
        });
      }
      if (m.items) {
        m.items.forEach((i) => {
          if (i.routerLink && i.routerLink.length > 0) {
            i.routerLink.forEach((r) => {
              urls.push(r);
            });
          }
        });
      }
    });
    this.menuSrv.nextMenu(urls);
  }

  private getReports(): IMenu {
    return {
      label: "Relatórios",
      icon: "fas fa-file-alt",
      items: [
        {
          label: "Relatório Individual",
          icon: "fas fa-file",
          routerLink: ["/reports/individual"],
        },
        {
          label: "Relatório Consolidado",
          icon: "fas fa-file",
          routerLink: ["/reports/consolidated"],
        },
        {
          label: "Relatório de Respostas",
          icon: "fas fa-file",
          routerLink: ["/reports/score-question"],
        },
        {
          label: "Relatório Personalizado",
          icon: "fas fa-file",
          routerLink: ["/reports/custom-reports"],
        },
      ],
    };
  }

  private getComunication(): IMenu {
    return {
      label: "Comunicações",
      icon: "fas fa-comments",
      items: [
        {
          label: "Canal de comunicação",
          icon: "fas fa-comment-dots",
          routerLink: ["/jurisdicted/comunications"],
        },
      ],
    };
  }

  private getJurisdicted(manager: boolean, auditor: boolean): IMenu {
    const menuJurisdicted = {
      label: "Jurisdicionado",
      icon: "pi pi-fw pi-sitemap",
      items: [],
    };
    if (manager) {
      menuJurisdicted.items.push({
        label: "Alocação de questionário",
        icon: "pi pi-fw pi-external-link",
        routerLink: ["/jurisdicted"],
      });
    }
    if (auditor) {
      menuJurisdicted.items.push({
        label: "Canal de comunicação",
        icon: "fas fa-comment-dots",
        routerLink: ["/comunications"],
      });
      menuJurisdicted.items.push({
        label: "Questionários",
        icon: "pi pi-list",
        routerLink: ["/jurisdicted/auditor-view-questionnaires-list"],
      });
    }

    return menuJurisdicted;
  }

  private getConfiguration(userRoles: UserRoleEnum[]): IMenu {
    const menu = {
      label: "Configurações",
      icon: "fas fa-cogs",
      items: [
        {
          label: "Controle de envio dos e-mails",
          icon: "fas fa-mail-bulk",
          routerLink: ["/emails"],
        },
      ],
    };
    if (userRoles.includes(UserRoleEnum.MASTER)) {
      menu.items.push({
        label: "Parâmetros",
        icon: "fas fa-sliders-h",
        routerLink: ["/parameters"],
      });
    }
    return menu;
  }

  private getFiscalization(adm: boolean, auditor: boolean): IMenu {
    const menuFiscalization = {
      label: "Fiscalizações",
      icon: "fas fa-clipboard-list",
      items: [],
    };
    if (adm) {
      menuFiscalization.items.push({
        label: "Liberação de comentários e anexos",
        icon: "fas fa-thumbs-up",
        routerLink: ["/fiscalization/content-review"],
      });
    }
    if (auditor) {
      menuFiscalization.items.push({
        label: "Responder Fiscalização",
        icon: "fas fa-edit",
        routerLink: ["/fiscalization/answer"],
      });
      menuFiscalization.items.push({
        label: "Revisão da Fiscalização",
        icon: "fas fa-clipboard-check",
        routerLink: ["/fiscalization/review"],
      });
      menuFiscalization.items.push({
        label: "Consulta de revisão",
        icon: "fas fa-search",
        routerLink: ["/fiscalization/search-review"],
      });
      menuFiscalization.items.push({
        label: "Fórmula de Pontuação",
        icon: "fas fa-calculator",
        routerLink: ["/fiscalization/formula-questions"],
      });
    }
    return menuFiscalization;
  }

  private getPlanning(): IMenu {
    return {
      label: "Planejamento",
      icon: "pi pi-fw pi-briefcase",
      items: [
        {
          label: "Fiscalização",
          icon: "pi pi-fw pi-sort-amount-up",
          routerLink: ["/planning/fiscalization"],
        },
      ],
    };
  }

  private getDashBoard(): IMenu {
    return { label: "Dashboard", icon: "pi pi-fw pi-home", routerLink: ["/"] };
  }

  private getBasics(): IMenu {
    return {
      label: "Cadastros",
      icon: "pi pi-fw pi-table",
      items: [
        {
          label: "Tipo de Fiscalização",
          icon: "pi pi-fw pi-table",
          routerLink: ["/type-fiscalization"],
        },
        {
          label: "Categoria de Fiscalização",
          icon: "pi pi-fw pi-sliders-v",
          routerLink: ["/category-fiscalization"],
        },
        {
          label: "Dimensão do questionário",
          icon: "pi pi-fw pi-bars",
          routerLink: ["/questionnaire-dimension"],
        },
        {
          label: "Tipo de Questão",
          icon: "pi pi-fw pi-sort-alpha-down-alt",
          routerLink: ["/type-question"],
        },
        {
          label: "Categoria da Questão",
          icon: "pi pi-fw pi-sliders-h",
          routerLink: ["/category-question"],
        },
        {
          label: "Questão",
          icon: "pi pi-fw pi-comment",
          routerLink: ["/question"],
        },
        {
          label: "Configuração Dashboards",
          icon: "pi pi-fw pi-cog",
          routerLink: ["/dashboard/config"],
        },
        {
          label: "Unidade Administrativa",
          icon: "pi pi-fw pi-sitemap",
          routerLink: ["/administrative-unit"],
        },
        {
          label: "Importação de dados",
          icon: "pi pi-fw pi-external-link",
          url: "https://formulario-capture.apps.tcema.tc.br/login",
          target: "_blank",
        },
      ],
    };
  }
}
